import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_FAB } from "@/constants/testIds";
import { useSiteSettings } from "@/hooks/useSiteSettings";

/**
 * Global WhatsApp support helper.
 * Reads the number from Admin → Site Settings (`GET /classifieds/site-settings?country=NZ`)
 * — hidden entirely when the founder hasn't set one yet (no hardcoded fallback).
 * Spec: WEB_SPEC_PAY_AT_STORE_AND_UPDATE3 §4.
 */
export default function WhatsAppFAB() {
  const { data: settings } = useSiteSettings();
  const raw = settings?.whatsapp;
  if (!raw) return null;
  const digits = String(raw).replace(/[^0-9]/g, "");
  if (!digits) return null;

  return (
    <a
      data-testid={WHATSAPP_FAB}
      href={`https://wa.me/${digits}?text=${encodeURIComponent("Kia Ora — I have a question about Allsale Classified.")}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 wa-pulse relative inline-flex items-center justify-center w-14 h-14 rounded-full text-white shadow-dropdown"
      style={{ backgroundColor: "var(--whatsapp)" }}
      aria-label="Chat with us on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
